import { useContext } from "react";
import { SolrContext } from "./solr-provider";

/**
 * Custom hook to access the solr context.
 * @returns {Object} The solr context object.
 */
const useSolrContext = () => {
  const solrContext = useContext(SolrContext);
  return solrContext;
};

export default useSolrContext;
